export const handleCardDisplay = (cardNumber) => {
  let rawText = [...cardNumber.split(" ").join("")]; // Remove old space
  rawText = rawText.filter((x) => is_numeric(x))
  const creditCard = []; // Create card as array
  rawText.forEach((t, i) => {
    if (i % 4 === 0 && i !== 0) creditCard?.push(" "); // Add space
    creditCard.push(t);
  });
  return creditCard?.join(""); // Transform card array to string
};

export function is_numeric(str) {
  return /^\d+$/.test(str);
}